<app-leveltwo [pageId]="2">
  <div class="General">

      <h3>{{'MultispecialtyClinics.SearchTitle'|translate}}</h3>

      <p><a href="#">{{'MultispecialtyClinics.Section214'|translate}}</a> {{'MultispecialtyClinics.expandsthe'|translate}} <a href="#">{{'MultispecialtyClinics.section1206'|translate}}</a></p>

      <ol>
        <li>{{'MultispecialtyClinics.Aclinic'|translate}}</li>
        <li>{{'MultispecialtyClinics.Whichconducts'|translate}}</li>
        <li>{{'MultispecialtyClinics.Througha'|translate}}</li>
        <li>{{'MultispecialtyClinics.Whoare'|translate}}</li>
        <li>{{'MultispecialtyClinics.Representing'|translate}}</li>
        <li>{{'MultispecialtyClinics.Notless'|translate}}</li>
      </ol>

      <p>{{'MultispecialtyClinics.Themultiscpecialty'|translate}} <a href="#">{{'MultispecialtyClinics.Section214'|translate}}</a>{{'MultispecialtyClinics.orisnot'|translate}} <a href="#">{{'MultispecialtyClinics.section1206'|translate}}</a>
      {{'MultispecialtyClinics.maystill'|translate}}
      </p>




  </div>
</app-leveltwo>
